export default {
	IDLE: {
		on: {
			connect: 'CONNECTING',
		},
	},
	CONNECTING: {
		on: {
			agentReady: 'CONFIGURING',
		},
	},
	CONFIGURING: {
		on: {
			configuration: 'READY',
			taskError: 'ERROR',
		},
	},
	READY: {
		on: {
			action: 'STARTING',
		},
	},
	STARTING: {
		on: {
			started: 'MEASURING',
			error: 'ERROR',
		},
	},
	MEASURING: {
		on: {
			action: 'CANCELING',
			taskError: 'ERROR',
			taskComplete: 'COMPLETED',
		},
	},
	CANCELING: {
		on: {
			taskComplete: 'CANCELLED',
		},
	},
	RESETTING: {
		on: {
			agentReady: 'STARTING',
		},
	},
	CANCELLED: {
		on: {
			action: 'RESETTING',
		},
	},
	COMPLETED: {
		on: {
			action: 'RESETTING',
		},
	},
	ERROR: {
		on: {},
	},
};
